    (function($) {

        var wow = new WOW(
      {
        mobile: false
    }
    )
    wow.init();

	$(window).on('scroll',function(){
		var scrollTop = $(this).scrollTop(),
            headerInnerHeight = $('.header-inner').innerHeight(),
            headerLower = $('.header-lower'),
            headerLowerHeight = headerLower.innerHeight();

            if(scrollTop > headerInnerHeight && !headerLower.hasClass('fixed-header')) {
                $('.header-lower').addClass('fixed-header');
                $('#content').css('padding-top',headerLowerHeight + 'px');
            }

            else if(scrollTop < headerInnerHeight && headerLower.hasClass('fixed-header')) {
                $('.header-lower').removeClass('fixed-header');
                $('#content').css('padding-top','0px');
            }


	});

	$(document).ready(function(){
		  $('.projects-preview-slider').slick({
		    infinite: true,
		    arrows: false,
		    slidesToShow: 3,
            centermode: true,
		    autoplay: true,
		    //appendArrows: $('.projects-preview-arrows'),
		    fade: false,
            pauseOnFocus: false,
            pauseOnHover: false,

            responsive: [
            {
              breakpoint: 1600,
              settings: {
               slidesToShow: 2,
              }
            },

             {
              breakpoint: 1179,
              settings: {
                slidesToShow: 1,
                fade: true,
                centermode: false,
              }
            },
            ],
		  });

		   $('.partner-logos-slider').slick({
		    infinite: true,
		    arrows: false,
		    slidesToShow: 6,
		    autoplay: true,
            autoplaySpeed: 0,
            speed: 2000,
		    dots: false,
		   responsive: [
		    {
		      breakpoint: 768,
		      settings: {
		        slidesToShow: 4,
		        centerMode: true,
		      }
		    },

             {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                centerMode: true,
              }
            },
		    ],
		  });

        $('.posts-slider').slick({
            infinite: true,
            arrows: false,
            slidesToShow: 3,
            autoplay: true,
            dots: true,
           responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerMode: true,
              }
            },
            ],
          });

        $('.testimonials-slider').slick({
            infinite: true,
            arrows: false,
            slidesToShow: 1,
            autoplay: false,
            dots: true,
            appendDots: $('div#testimonial-dots'),
            adaptiveHeight: false,
          });

        $('.product-cat-slider').slick({
            infinite: true,
            arrows: true,
            slidesToShow: 3,
            autoplay: true,
            dots: false,
            appendArrows: $('#category-slider-control'),
            prevArrow: '<button type="button" class="cat-prev"></button>',
            nextArrow: '<button type="button" class="cat-next"></button>',
           responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
              }
            },

             {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
              }
            },
            ],
          });

            //This option is for pages with a slider of images
    //var lightbox = new SimpleLightbox('.image-gallery>.single-image>a', { /* options */ });
    //var lightboxGrid = new SimpleLightbox('.image-gallery-grid>.single-image>a', { /* options */ });
    

    var windowWidth = $(window).width();

        if(windowWidth > 1170) {
            var centerPadAmount = (windowWidth - 1170) / 2;
        }

        else {
            var centerPadAmount = 20;
        }

        //var lightboxGall = new SimpleLightbox('.image-gallery-extra>.single-image>a', { /* options */ });

        var gallerySlider = function($selector) { 

        var galleryArrows = $($selector).siblings('.gallery-arrows');
            
        $($selector).slick({
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        autoplay:true,
        initialSlide: 0,
        centerMode: true,
        centerPadding: centerPadAmount + 'px',
        appendArrows: galleryArrows,
        prevArrow: '<button type="button" class="cat-prev"></button>',
        nextArrow: '<button type="button" class="cat-next"></button>',
        fade: false,
        responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: true,
                slidesToShow: 1,
              }
            }
            ],
        });
        }

        //gallerySlider('.image-gallery-header-slider');

        var imageGalleryExtra = $('.image-gallery-extra');

        $(imageGalleryExtra).each(function(){
            gallerySlider(this);
        });
	});

    var resizeItem = function($selector) {
        var itemSize = 0;

        $($selector).each(function(i){
                if($(this).innerHeight() > itemSize) {
                    itemSize = $(this).innerHeight();
                }
        })

        $($selector).css('height',itemSize + 'px');
           
        };

    $(window).on('load',function(){
        resizeItem('.headline-wrapper');
    });
    

//open and close search menu
$('button.search-toggle').on("click", function (event) {
    event.preventDefault();
    $('body').toggleClass('search-open');
    event.stopPropagation();
});

$(document).bind('keydown', function(e) {
	//alert(e.which);
    if (e.which == 27) {
        $('body').removeClass('search-open');
    }
}); 

/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMap( $el ) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map ) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        map: map
    });

    // Append to reference for later use.
    map.markers.push( marker );

    // If marker contains HTML, add it to an infoWindow.
    if( $marker.html() ){

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}

// Render maps on page load.
$(document).ready(function(){
    $('.acf-map').each(function(){
        var map = initMap( $(this) );
    });
});


    $(window).on('load',function() {        
        // Animate loader off screen
        $("#loader").fadeOut(100);
    });

//animate all anchor links

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth',
            block: "nearest", 
        });
    });
});

})( jQuery );